import classnames from 'classnames';
import { PointerEvent as ReactPointerEvent } from 'react';

import { ResizeDirection } from '../../../../hooks/usePanelGeometry';

import styles from './sidekickResizeHandles.module.scss';

const DIRECTIONS: ResizeDirection[] = [
  'n',
  's',
  'e',
  'w',
  'ne',
  'nw',
  'se',
  'sw',
];

type SidekickResizeHandlesProps = {
  onResizeStart: (
    _direction: ResizeDirection,
  ) => (event: ReactPointerEvent<HTMLElement>) => void;
};

/** Edge and corner handles that resize the surrounding fixed-position panel. */
export const SidekickResizeHandles = ({
  onResizeStart,
}: SidekickResizeHandlesProps): JSX.Element => {
  return (
    <>
      {DIRECTIONS.map((direction) => (
        <div
          key={direction}
          className={classnames(styles.handle, styles[direction])}
          onPointerDown={onResizeStart(direction)}
        />
      ))}
    </>
  );
};
